<template>
<div class="demo-container" id="nav-scroller" ref="content">
  <header role="banner">
      <div class="top-bar">
        <div class="container">
          <div class="row">
            <div class="col-9 social">
              <a href="#"><span class="fa fa-twitter"></span></a>
              <a href="#"><span class="fa fa-facebook"></span></a>
              <a href="#"><span class="fa fa-instagram"></span></a>
              <a href="#"><span class="fa fa-youtube-play"></span></a>
              <a href="#"><span class="fa fa-vimeo"></span></a>
              <a href="#"><span class="fa fa-snapchat"></span></a>
            </div>
            <div class="col-3 search-icon">
              <a href="#"><span class="pe pe-7s-search"></span></a>
            </div>
          </div>
        </div>
      </div>

      <div class="container logo-wrap">
        <div class="row pt-5">
          <div class="col-12 text-center">
            <a class="absolute-toggle d-block d-md-none" data-toggle="collapse" href="#navbarMenu" role="button" aria-expanded="false" aria-controls="navbarMenu"><span class="burger-lines"></span></a>
            <h1><a href="index.html">Balita</a></h1>
          </div>
        </div>
      </div>

      <nav class="navbar navbar-expand-md  navbar-light bg-light">
        <div class="container">


          <div class="collapse navbar-collapse" id="navbarMenu">
            <ul class="navbar-nav mx-auto">
              <li class="nav-item">
                <a class="nav-link active" href="index.html">Home</a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="category.html" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Fashion</a>
                <div class="dropdown-menu" aria-labelledby="dropdown04">
                  <a class="dropdown-item" href="category.html">Asia</a>
                  <a class="dropdown-item" href="category.html">Europe</a>
                  <a class="dropdown-item" href="category.html">Dubai</a>
                  <a class="dropdown-item" href="category.html">Africa</a>
                  <a class="dropdown-item" href="category.html">South America</a>
                </div>

              </li>

              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="category.html" id="dropdown05" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Style</a>
                <div class="dropdown-menu" aria-labelledby="dropdown05">
                  <a class="dropdown-item" href="category.html">Fashion</a>
                  <a class="dropdown-item" href="category.html">Business</a>
                  <a class="dropdown-item" href="category.html">Travel</a>
                  <a class="dropdown-item" href="category.html">Style</a>
                  <a class="dropdown-item" href="category.html">Grooming</a>
                </div>

              </li>
              <li class="nav-item">
                <a class="nav-link" href="blog.html">Grooming</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="about.html">Hair</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="contact.html">Street Style</a>
              </li>
            </ul>

          </div>
        </div>
      </nav>
    </header>
    <!-- END header -->

    <section class="site-section py-lg">
      <div class="container">

        <div class="row blog-entries">
          <div class="col-md-12 col-lg-8 main-content">
            <h1 class="mb-4">Travel In Style This Summer With Our July Capsule Wardrobe</h1>
            <div class="post-meta">
                        <span class="category">Style</span>
                        <span class="mr-2">August 13, 2019 </span> &bullet;
                        <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                      </div>
            <div class="post-content-body">
              <h3 class="mb-4">What to pack to look your best on vacation</h3>
              <p>We’re continuing our Capsule Wardrobe series this month with a focus  on summer vacation and travel. While a summer vacation is most certainly  about rest and relaxation, that doesn’t mean your style needs to take a  vacation as well. There are definitely ways to keep it relaxed and stay  tailored and dapper at the same time. And that’s what the 10 pieces in  our July collection are all about.</p>

              <!--  unstitched.xyz outfit -->
              <div class="unstitched__iframe-wrapper" style="padding-top: 30px;">
                <iframe id="unstitched__iframe_capsule_19" src="https://api.unstitched.xyz/capsules/19/iframe" width="100%" frameBorder="0" scrolling="no" onload="iFrameResize({checkOrigin: false}, '#unstitched__iframe_capsule_19')">
                  <p>Your browser does not support iframes. Click <a href="https://api.unstitched.xyz/capsules/19/iframe">here</a> to see this outfit.</p>
                </iframe>
              </div>
              <!-- END  unstitched.xyz outfit -->

              <p>Here are the 10 pieces:</p>
              <ul>
                <li>Cream linen blazer</li>
                <li>Pattered blazer</li>
                <li>Lightweight light blue denim shirt</li>
                <li>Black polo shirt</li>
                <li>Printed shirt</li>
                <li>Khaki linen pants</li>
                <li>Stone/white cotton pants</li>
                <li>Panama hat</li>
                <li>Brown horse bit loafers</li>
                <li>Black espadrilles</li>
              </ul>

              <p>And here are several ways to style them.</p>

              <h3 class="mt-5">Airport Ready</h3>
              <!--  unstitched.xyz outfit -->
              <div class="unstitched__iframe-wrapper" style="padding-top: 30px;">
                <iframe id="unstitched__iframe_outfit_43" src="https://api.unstitched.xyz/outfits/43/embedded" width="100%" frameBorder="0" scrolling="no" onload="iFrameResize({checkOrigin: false}, '#unstitched__iframe_outfit_43')">
                  <p>Your browser does not support iframes. Click <a href="https://api.unstitched.xyz/outfits/43/embedded">here</a> to see this outfit.</p>
                </iframe>
              </div>
              <!-- END  unstitched.xyz outfit -->
              <p>There are a few key things to keep in mind when considering your airport  style. Be sure to wear a pair of loafers. They’re easy to slip on and  off, which makes traveling through the security line that much easier.  If you are bringing two blazers on your trip, wear one to the airport to  save it from getting wrinkled in your suitcase. (Remember, even if you know how to pack it,  wrinkles are unavoidable.) When you get on the plane, simply remove it,  fold it once lengthwise and then in half again and stow in the overhead  compartment. And if you plan to bring a hat, it is best to wear it to  the airport rather than pack it in a bag.</p>

              <h3 class="mt-4">Resort Dinner</h3>
              <!--  unstitched.xyz outfit -->
              <div class="unstitched__iframe-wrapper" style="padding-top: 30px;">
                <iframe id="unstitched__iframe_outfit_44" src="https://api.unstitched.xyz/outfits/44/embedded" width="100%" frameBorder="0" scrolling="no" onload="iFrameResize({checkOrigin: false}, '#unstitched__iframe_outfit_44')">
                  <p>Your browser does not support iframes. Click <a href="https://api.unstitched.xyz/outfits/44/embedded">here</a> to see this outfit.</p>
                </iframe>
              </div>
              <!-- END  unstitched.xyz outfit -->
              <p>A nice dinner at your resort is the time to break out your best sport coat. Keep it casual with a lightweight denim shirt and cotton trousers and finish the look off with a fun pair of loafers.</p>

              <h3 class="mt-4">Day Tripping</h3>
              <!--  unstitched.xyz outfit -->
              <div class="unstitched__iframe-wrapper" style="padding-top: 30px;">
                <iframe id="unstitched__iframe_outfit_45" src="https://api.unstitched.xyz/outfits/45/embedded" width="100%" frameBorder="0" scrolling="no" onload="iFrameResize({checkOrigin: false}, '#unstitched__iframe_outfit_45')">
                  <p>Your browser does not support iframes. Click <a href="https://api.unstitched.xyz/outfits/45/embedded">here</a> to see this outfit.</p>
                </iframe>
              </div>
              <!-- END  unstitched.xyz outfit -->
              <p>Comfort and style do not have to be mutually exclusive. A short sleeve printed shirt and linen pants will keep you cool in both the looks and temperature departments. Espadrilles are a great utility shoe and a hat will save your face from the sun’s rays.</p>

              <h3 class="mt-4">Island Cocktails</h3>
              <!--  unstitched.xyz outfit -->
              <div class="unstitched__iframe-wrapper" style="padding-top: 30px;">
                <iframe id="unstitched__iframe_outfit_46" src="https://api.unstitched.xyz/outfits/46/embedded" width="100%" frameBorder="0" scrolling="no" onload="iFrameResize({checkOrigin: false}, '#unstitched__iframe_outfit_46')">
                  <p>Your browser does not support iframes. Click <a href="https://api.unstitched.xyz/outfits/46/embedded">here</a> to see this outfit.</p>
                </iframe>
              </div>
              <!-- END  unstitched.xyz outfit -->
              <p>A few tweaks make the last look more appropriate for sunset cocktails. Throw on your sport coat and swap your linen trousers for a more structured cotton pair with a cuff.</p>

              <h3 class="mt-4">Pool Lounging</h3>
              <!--  unstitched.xyz outfit -->
              <div class="unstitched__iframe-wrapper" style="padding-top: 30px;">
                <iframe id="unstitched__iframe_outfit_47" src="https://api.unstitched.xyz/outfits/47/embedded" width="100%" frameBorder="0" scrolling="no" onload="iFrameResize({checkOrigin: false}, '#unstitched__iframe_outfit_47')">
                  <p>Your browser does not support iframes. Click <a href="https://api.unstitched.xyz/outfits/47/embedded">here</a> to see this outfit.</p>
                </iframe>
              </div>
              <!-- END  unstitched.xyz outfit -->
              <p>Never underestimate the power of a simple polo shirt. Focus on a few accessories to kick it up a notch. And if it gets a little warmer, roll up your pant legs and dip your feet in the pool.</p>

              <h3 class="mt-4">Return Flight</h3>
              <!--  unstitched.xyz outfit -->
              <div class="unstitched__iframe-wrapper" style="padding-top: 30px;">
                <iframe id="unstitched__iframe_outfit_48" src="https://api.unstitched.xyz/outfits/48/embedded" width="100%" frameBorder="0" scrolling="no" onload="iFrameResize({checkOrigin: false}, '#unstitched__iframe_outfit_48')">
                  <p>Your browser does not support iframes. Click <a href="https://api.unstitched.xyz/outfits/48/embedded">here</a> to see this outfit.</p>
                </iframe>
              </div>
              <!-- END  unstitched.xyz outfit -->
              <p>Wear linen and cotton to keep those vacation vibes going on your way home.</p>
            </div>


            <div class="pt-5">
              <p>Categories:  <a href="#">Style</a>, <a href="#">Menswear</a>  Tags: <a href="#">#summer</a>, <a href="#">#travel</a></p>
            </div>


            <div class="pt-5">
              <h3 class="mb-5">6 Comments</h3>
              <ul class="comment-list">
                <li class="comment">
                  <div class="vcard">
                    <img src="@/assets/img/demo-blog/person_1.jpg" alt="Image placeholder">
                  </div>
                  <div class="comment-body">
                    <h3>Jean Doe</h3>
                    <div class="meta">January 9, 2018 at 2:21pm</div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                    <p><a href="#" class="reply">Reply</a></p>
                  </div>
                </li>

                <li class="comment">
                  <div class="vcard">
                    <img src="@/assets/img/demo-blog/person_1.jpg" alt="Image placeholder">
                  </div>
                  <div class="comment-body">
                    <h3>Jean Doe</h3>
                    <div class="meta">January 9, 2018 at 2:21pm</div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                    <p><a href="#" class="reply">Reply</a></p>
                  </div>

                  <ul class="children">
                    <li class="comment">
                      <div class="vcard">
                        <img src="@/assets/img/demo-blog/person_1.jpg" alt="Image placeholder">
                      </div>
                      <div class="comment-body">
                        <h3>Jean Doe</h3>
                        <div class="meta">January 9, 2018 at 2:21pm</div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                        <p><a href="#" class="reply">Reply</a></p>
                      </div>
                    </li>
                  </ul>
                </li>

                <li class="comment">
                  <div class="vcard">
                    <img src="@/assets/img/demo-blog/person_1.jpg" alt="Image placeholder">
                  </div>
                  <div class="comment-body">
                    <h3>Jean Doe</h3>
                    <div class="meta">January 9, 2018 at 2:21pm</div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                    <p><a href="#" class="reply">Reply</a></p>
                  </div>
                </li>
              </ul>
              <!-- END comment-list -->

              <div class="comment-form-wrap pt-5">
                <h3 class="mb-5">Leave a comment</h3>
                <form action="#" class="p-5 bg-light">
                  <div class="form-group">
                    <label for="name">Name *</label>
                    <input type="text" class="form-control" id="name">
                  </div>
                  <div class="form-group">
                    <label for="email">Email *</label>
                    <input type="email" class="form-control" id="email">
                  </div>
                  <div class="form-group">
                    <label for="website">Website</label>
                    <input type="url" class="form-control" id="website">
                  </div>

                  <div class="form-group">
                    <label for="message">Message</label>
                    <textarea name="" id="message" cols="30" rows="10" class="form-control"></textarea>
                  </div>
                  <div class="form-group">
                    <input type="submit" value="Post Comment" class="btn btn-primary">
                  </div>

                </form>
              </div>
            </div>

          </div>

          <!-- END main-content -->

          <div class="col-md-12 col-lg-4 sidebar">
            <div class="sidebar-box search-form-wrap">
              <form action="#" class="search-form">
                <div class="form-group">
                  <span class="icon pe pe-7s-search"></span>
                  <input type="text" class="form-control" id="s" placeholder="Type a keyword and hit enter">
                </div>
              </form>
            </div>
            <!-- END sidebar-box -->
            <div class="sidebar-box">
              <div class="bio text-center">
                <img src="@/assets/img/demo-blog/person_1.jpg" alt="Image Placeholder" class="img-fluid">
                <div class="bio-body">
                  <h2>Unstitched Team</h2>
                  <p>This is a demo blog to show case how you can embed Unstitched content directly into your blog posts.</p>
                  <p><a href="#" class="btn btn-primary btn-sm">Sign up now</a></p>
                  <p class="social">
                    <a href="#" class="p-2"><span class="fa fa-facebook"></span></a>
                    <a href="#" class="p-2"><span class="fa fa-twitter"></span></a>
                    <a href="#" class="p-2"><span class="fa fa-instagram"></span></a>
                    <a href="#" class="p-2"><span class="fa fa-youtube-play"></span></a>
                  </p>
                </div>
              </div>
            </div>
            <!-- END sidebar-box -->
            <div class="sidebar-box">
              <h3 class="heading">Popular Posts</h3>
              <div class="post-entry-sidebar">
                <ul>
                  <li>
                    <a href="">
                      <img src="@/assets/img/demo-blog/neutrals_sm.jpg" alt="Image placeholder" class="mr-4">
                      <div class="text">
                        <h4>6 Easy Ways To Wear Neutrals</h4>
                        <div class="post-meta">
                          <span class="mr-2">July 15, 2019 </span> &bullet;
                          <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img src="@/assets/img/demo-blog/peaky_blinders_sm.jpg" alt="Image placeholder" class="mr-4">
                      <div class="text">
                        <h4>How To Get The Peaky Blinders Look</h4>
                        <div class="post-meta">
                          <span class="mr-2">July 29, 2019 </span> &bullet;
                          <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                        </div>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img src="@/assets/img/demo-blog/style_icons.jpg" alt="Image placeholder" class="mr-4">
                      <div class="text">
                        <h4>Meet The Next Generation Of Men’s Style Icons</h4>
                        <div class="post-meta">
                          <span class="mr-2">August 2, 2019 </span> &bullet;
                          <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- END sidebar-box -->

            <div class="sidebar-box">
              <h3 class="heading">Categories</h3>
              <ul class="categories">
                <li><a href="#">Style <span>(42)</span></a></li>
                <li><a href="#">Travel <span>(22)</span></a></li>
                <li><a href="#">Grooming <span>(37)</span></a></li>
                <li><a href="#">Business <span>(12)</span></a></li>
                <li><a href="#">Fashion Week <span>(14)</span></a></li>
              </ul>
            </div>
            <!-- END sidebar-box -->

            <div class="sidebar-box">
              <h3 class="heading">Tags</h3>
              <ul class="tags">
                <li><a href="#">Fashion</a></li>
                <li><a href="#">Travel</a></li>
                <li><a href="#">Style</a></li>
                <li><a href="#">Lifestyle</a></li>
                <li><a href="#">Business</a></li>
                <li><a href="#">Hair</a></li>
                <li><a href="#">Fashion Week</a></li>
                <li><a href="#">Summar</a></li>
                <li><a href="#">Street Style</a></li>
                <li><a href="#">Sunglasses</a></li>
                <li><a href="#">Winter</a></li>
                <li><a href="#">Shoes</a></li>
              </ul>
            </div>
          </div>
          <!-- END sidebar -->

        </div>
      </div>
    </section>

    <section class="py-5">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="mb-3 ">Related Post</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-lg-4">
            <a href="#" class="a-block d-flex align-items-center height-md" :style="{backgroundImage: 'url('+require('@/assets/img/demo-blog/img_4.jpg')+')'}">
              <div class="text">
                <div class="post-meta">
                  <span class="category">Style</span>
                  <span class="mr-2">July 14, 2019 </span> &bullet;
                  <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                </div>
                <h3>There’s a Cool New Way for Men to Wear Socks and Sandals</h3>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-lg-4">
            <a href="#" class="a-block d-flex align-items-center height-md" :style="{backgroundImage: 'url('+require('@/assets/img/demo-blog/peaky_blinders_sm.jpg')+')'}">
              <div class="text">
                <div class="post-meta">
                  <span class="category">Style</span>
                  <span class="mr-2">July 29, 2019 </span> &bullet;
                  <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                </div>
                <h3>How To Get The Peaky Blinders Look</h3>
              </div>
            </a>
          </div>
          <div class="col-md-6 col-lg-4">
            <a href="#" class="a-block d-flex align-items-center height-md" :style="{backgroundImage: 'url('+require('@/assets/img/demo-blog/style_icons.jpg')+')'}">
              <div class="text">
                <div class="post-meta">
                  <span class="category">Lifestyle</span>
                  <span class="mr-2">August 2, 2019 </span> &bullet;
                  <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                </div>
                <h3>Meet The Next Generation Of Men’s Style Icons</h3>
              </div>
            </a>
          </div>
        </div>
      </div>


    </section>
    <!-- END section -->

    <footer class="site-footer">
      <div class="container">
        <div class="row mb-5">
          <div class="col-md-4">
            <h3>Paragraph</h3>
            <img src="@/assets/img/demo-blog/img_1.jpg" alt="Image placeholder" class="img-fluid">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi, accusantium optio unde perferendis eum illum voluptatibus dolore tempora, consequatur minus asperiores temporibus reprehenderit.</p>
          </div>
          <div class="col-md-6 ml-auto">
            <div class="row">
              <div class="col-md-7">
                <h3>Latest Post</h3>
                <div class="post-entry-sidebar">
                  <ul>
                    <li>
                      <a href="">
                        <img src="@/assets/img/demo-blog/img_6.jpg" alt="Image placeholder" class="mr-4">
                        <div class="text">
                          <h4>There’s a Cool New Way for Men to Wear Socks and Sandals</h4>
                          <div class="post-meta">
                            <span class="mr-2">July 14, 2019 </span> &bullet;
                            <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="">
                        <img src="@/assets/img/demo-blog/img_3.jpg" alt="Image placeholder" class="mr-4">
                        <div class="text">
                          <h4>How To Get The Peaky Blinders Look</h4>
                          <div class="post-meta">
                            <span class="mr-2">July 29, 2019 </span> &bullet;
                            <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="">
                        <img src="@/assets/img/demo-blog/img_4.jpg" alt="Image placeholder" class="mr-4">
                        <div class="text">
                          <h4>Meet The Next Generation Of Men’s Style Icons</h4>
                          <div class="post-meta">
                            <span class="mr-2">August 2, 2019 </span> &bullet;
                            <span class="ml-2"><span class="pe pe-7s-comment"></span> 3</span>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-md-1"></div>

              <div class="col-md-4">

                <div class="mb-5">
                  <h3>Quick Links</h3>
                  <ul class="list-unstyled">
                    <li><a href="#">Fashion</a></li>
                    <li><a href="#">Style</a></li>
                    <li><a href="#">Grooming</a></li>
                    <li><a href="#">Street Style</a></li>
                    <li><a href="#">Hair</a></li>
                  </ul>
                </div>

                <div class="mb-5">
                  <h3>Social</h3>
                  <ul class="list-unstyled footer-social">
                    <li><a href="#"><span class="fa fa-twitter"></span> Twitter</a></li>
                    <li><a href="#"><span class="fa fa-facebook"></span> Facebook</a></li>
                    <li><a href="#"><span class="fa fa-instagram"></span> Instagram</a></li>
                    <li><a href="#"><span class="fa fa-vimeo"></span> Vimeo</a></li>
                    <li><a href="#"><span class="fa fa-youtube-play"></span> Youtube</a></li>
                    <li><a href="#"><span class="fa fa-snapchat"></span> Snapshot</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!-- END footer -->
</div>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';
import '../plugins/iframeResizer.js'

export default {
  mounted () {
    this.setShowHeader(false);
  },

  destroyed () {
    this.setShowHeader(true);
  },


  methods: {
    ...mapActions([
      'setShowHeader'
    ])
  }
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Josefin+Sans:300,400,700&display=swap');
@import "~@/styles/_demo-blog.scss";
</style>



// WEBPACK FOOTER //
// src/pages/DemoBlog.vue